export default "__VITE_ASSET__CQ9U5hRs__"